<template>
<div class="overall-button">
  <div class="navbar-right">
    <div class="dropdown">
      <a class="float dropdown-toggle pointer"  role="button" id="dropdownMenuButton" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        <span class="center-icon-lang">
          <i class="zmdi zmdi-translate" />
          {{this.languageGlobal}}
        </span>
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item pointer" v-bind:class="{ selectedLang: this.languageGlobal === 'ES' }"
          @click="selLanguage('ES')">ES | Castellano</a>
        <a class="dropdown-item pointer" v-bind:class="{ selectedLang: this.languageGlobal === 'CT' }"
          @click="selLanguage('CT')">CT | Catalán</a>
        <a class="dropdown-item pointer" v-bind:class="{ selectedLang: this.languageGlobal === 'EU' }"
          @click="selLanguage('EU')">EU | Euskera</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'language',
  mounted() {
    const lang = window.localStorage.getItem('language');

    if (lang !== undefined && lang !== null) {
      this.languageGlobal = lang;
    }
  },
  methods: {
    /**
    * @method selLanguage
    * @description Selecciona el idioma y guarda en el localStorage
    * @param key Key del idioma
    */
    selLanguage(key) {
      this.languageGlobal = key;
      window.localStorage.setItem('language', this.languageGlobal);
    },
  },
};
</script>

<style>

.overall-button {
  z-index: 9999;
  position: absolute;
}
.pointer {
  cursor: pointer;
}
.selectedLang {
  color: #0c7ce6 !important;
}
.center-icon-lang {
  margin: auto auto;
  line-height: 60px;
}


.float{
  position:fixed;
  width:60px;
  height:60px;
  bottom:40px;
  right:40px;
  background-color: #0c7ce6;
  color: white;
  border-radius:50px;
  text-align:center;
  box-shadow: 2px 2px 3px #999;
}

a.float + div.label-container {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s ease;
}

a.float:hover + div.label-container{
  visibility: visible;
  opacity: 1;
}

a.float:hover .user-req-list {
  visibility: collapse;
}

.user-req-list {
  visibility: hidden;
}

a.float i {
  color: white;
}

</style>
